// @flow
import CopyInside from './CopyInside';

export default CopyInside;
